var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneralRadiobuttonOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.75C4.98438 14.75 2.6875 13.4375 1.42969 11.25C0.171875 9.08984 0.171875 6.4375 1.42969 4.25C2.6875 2.08984 4.98438 0.75 7.5 0.75C9.98828 0.75 12.2852 2.08984 13.543 4.25C14.8008 6.4375 14.8008 9.08984 13.543 11.25C12.2852 13.4375 9.98828 14.75 7.5 14.75ZM10.5898 6.46484H10.5625C10.8359 6.21875 10.8359 5.80859 10.5625 5.53516C10.3164 5.28906 9.90625 5.28906 9.66016 5.53516L6.625 8.59766L5.33984 7.3125C5.06641 7.03906 4.65625 7.03906 4.41016 7.3125C4.13672 7.55859 4.13672 7.96875 4.41016 8.21484L6.16016 9.96484C6.40625 10.2383 6.81641 10.2383 7.08984 9.96484L10.5898 6.46484Z",
    fill: "#1C32F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralRadiobuttonOn);
export default __webpack_public_path__ + "static/media/general-radiobutton-on.3d5c769caf9d462ee9a952e2784f5db2.svg";
export { ForwardRef as ReactComponent };